/**
 * @Author: DJ
 * @Date:   2021-09-06 17:11:12
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-09 14:45:53
 */
/**
 * 生成对账单 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import model from '@/reducers/finance/microbusinessesstatements/model';
import { XScrollSelect } from '@/components/xqxc_ui';
import { Modal, Input, Form, DatePicker, message, Select, Alert } from 'antd';
import styles from './ManualPay.module.scss';
import * as api from '@/apis/finance/microtransportstatements';
import moment from 'moment';

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};
const { Option } = Select;
class NoLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            title: this.props.title,
            visible: this.props.visible,
            shopObj: {},
            dates: [],
            smallTransportList: [],
            pageNumBranchBank: 1,
        };
    }
    componentDidMount() {
        // this.props.getOpearationList();
        this.getSmallTransportList();
    }

    getSmallTransportList = () => {
        api.smallTransportList({ pageSize: 50, pageNum: 1 }).then(res => {
            this.setState({ smallTransportList: res.result.dataList });
        }).catch((res) => {
            message.error(res.errDesc);
        });
    }

    loadBranchBank = (e) => {
        const { target } = e;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            api.smallTransportList({ pageSize: 50, pageNum: this.state.pageNumBranchBank + 1 })
                .then((res) => {
                    this.setState({ pageNumBranchBank: this.state.pageNumBranchBank + 1, smallTransportList: [...this.state.smallTransportList, ...res.result.dataList] });
                    // this.setState({smallTransportList:[...this.smallTransportList, ...res.result.dataList]});
                })
                .catch((err) => {
                    message.error(err.message);
                });
        }
    }
    onFocusB = (click) => {
        if (click) {
            this.setState({ pageNumBranchBank: 1 });
        }
    };

    formRef = React.createRef();
    // 点击确认
    _handleOk = () => {
        this.formRef.current.validateFields().then(async (fieldsValue) => {
            const { shopObj } = this.state;
            let startTime = fieldsValue.date[0].format('YYYY-MM-DD') + ' 00:00:00',
                endTime = fieldsValue.date[1].format('YYYY-MM-DD') + ' 23:59:59';
            let param = {
                targetId: shopObj.value,
                targetName: shopObj.children,
                settleMode: shopObj.settleMode,
                remark: fieldsValue.remark,
                startTime,
                endTime,
                opType: 'MANUAL',
                targetType: 'TRANSPORT'
            };
            http('/?cmd=com.xqxc.api.pig.mis.reconciliation.SmallTransportReconMisService.generater', param).then(res => {
                if (res && res.errCode === 0) {
                    message.success('操作成功!');
                    this.setState({ visible: false });
                    this.props.closeModal(true);
                } else {
                    message.error(res.errDesc);
                }

            }).catch((res) => {
                message.error(res.errDesc);
                // this.setState({ visible: false });
                // this.props.closeModal();
            });
        });
    };
    handleChange = (e, obj) => {
        this.setState({ shopObj: obj });
    }
    // 点击取消
    _handleCancel = () => {
        this.setState({ visible: false, pageNumBranchBank: 1 });
        this.props.closeModal();
    }
    disabledDate = current => {
        const { dates } = this.state;
        if (!dates || dates.length === 0) {
            return false;
        }
        const tooLate = dates[0] && current.diff(dates[0], 'days') > 70;
        const tooEarly = dates[1] && dates[1].diff(current, 'days') > 70;
        // const tooEarly = dates[1] && dates[1].diff(-1, 'days')>current;
        return tooEarly || tooLate;
    };
    onChange = e => {
        this.setState({ value: e });
    }
    onDatesChange = e => {
        this.setState({ dates: e });
    }
    onOpenChange = open => {
        if (open) {
            this.setState({ hackValue: [], dates: [] });
        } else {
            this.setState({ hackValue: undefined });
        }
    };
    render() {
        const { visible, confirmLoading, title, shopObj = {}, value, hackValue, smallTransportList } = this.state;
        const { dataList = [] } = this.props.OpearationList;
        return (
            <Modal
                width={610}
                centered
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Alert message="按起止日期生成对账单，最大间隔天数为70天；" type="error" style={{ marginBottom: 10, textAlign: 'left' }} />
                    <Form {...formItemLayout} name="control-ref" ref={this.formRef}>
                        <Form.Item
                            label='站点名称'
                            name='targetId'
                            rules={[{ required: true, message: '请选择站点' }]}
                        >
                            {/* <XScrollSelect
                                style={{ width: 450, textAlign: 'left' }}
                                url='/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.getMepPair'
                                placeholder='请选择站点'
                                showSearch
                                mainKey='epName'
                                selectID='id'
                                selectName='epName'
                                value={shopObj || {}}
                                listLabel='dataList'
                                isOptionBindID={true}
                                onChange={(value, item) => this.setState({ shopObj: item.props['data-option'] })}
                            /> */}
                            <Select
                                onPopupScroll={this.loadBranchBank}
                                onFocus={this.onFocusB}
                                showSearch
                                style={{ width: 320, left: 10, textAlign: 'left' }}
                                placeholder="请选择站点"
                                onChange={this.handleChange}
                                // options={OpearationList}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {smallTransportList && smallTransportList.map(i => {
                                    return <Option value={i.id} key={i.id} settleMode={i.settleType} >{i.transportName}</Option>
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label='起止日期'
                            name='date'
                            rules={[{ required: true, message: '请选择起止日期' }]}
                        >
                            <RangePicker
                                // disabledDate={cur => cur && (cur > moment().add(-1,'days'))}
                                style={{ width: 320, marginLeft: 10 }}
                                value={hackValue || value}
                                disabledDate={this.disabledDate}
                                onCalendarChange={this.onDatesChange}
                                onChange={this.onChange}
                            // onOpenChange={this.onOpenChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label='备注'
                            name='remark'
                        >
                            <TextArea rows={4} style={{ marginLeft: 10 }} />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

NoLogin.propTypes = {
    data: PropTypes.object, // 弹框入参
    form: PropTypes.object,
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string, // 弹框标题
    getOpearationList: PropTypes.func,
    OpearationList: PropTypes.array
};
const mapStateToProps = (state) => ({
    OpearationList: state.microbusinessesstatements.OpearationList,
});

export default connect(mapStateToProps, { ...model.actions })(NoLogin);